import { forwardRef, ForwardRefRenderFunction, PropsWithChildren, Ref } from 'react';

import { DisabledCursorBlocker, Inner, WarningContainer, WarningText, Wrapper } from './styles';
import { CardProps } from './types';

const Card: ForwardRefRenderFunction<HTMLDivElement, PropsWithChildren<CardProps>> = (
	{
		children,
		noPadding = false,
		disabled = false,
		maxWidth,
		innerMaxWidth,
		className,
		warningText,
		...props
	},
	ref?: Ref<HTMLDivElement>,
) => {
	return (
		<Wrapper
			{...props}
			ref={ref}
			className={className}
			$disabled={disabled}
			aria-disabled={disabled}
			$maxWidth={maxWidth}
		>
			{warningText && (
				<WarningContainer data-testid="warning-container">
					<WarningText>{warningText}</WarningText>
				</WarningContainer>
			)}
			{disabled && <DisabledCursorBlocker />}
			<Inner $noPadding={noPadding} $innerMaxWidth={innerMaxWidth}>
				{children}
			</Inner>
		</Wrapper>
	);
};

export default forwardRef<HTMLDivElement, PropsWithChildren<CardProps>>(Card);
